import React from "react";

export default function AccoladesSection() {
  const accolades = [
    {
      project: "NORCAT",
      award: "Consistent Business Growth Accolade",
      event: "AIXR, XR Awards",
      year: "2025",
      href: "https://xrawards.aixr.org/winners-and-finalists-2025/#category-outstanding-xr-company-of-the-year",
    },
    {
      project: "NORCAT",
      award: "Outstanding XR Company of the Year",
      event: "AIXR, XR Awards",
      year: "2025",
      href: "https://xrawards.aixr.org/winners-and-finalists-2025/#category-outstanding-xr-company-of-the-year",
    },
    {
      project: "Hoisting and Rigging VR (Finalist)",
      award: "Best Education & Training Solution",
      event: "AWE, Auggie Awards",
      year: "2025",
      href: "https://www.awexr.com/blog/Auggie-Awards-2025-Finalists-Announced",
    },
    {
      project: "Motor Control VR (Finalist)",
      award: "XR Education & Training of the Year",
      event: "AIXR, XR Awards",
      year: "2024",
      href: "https://xrawards.aixr.org/winners-and-finalists-2025/#category-xr-education-training-of-the-year",
    },
    {
      project: "Hoisting and Rigging VR",
      award: "Safety and Compliance Training Accolade",
      event: "AIXR, XR Awards",
      year: "2024",
      href: "https://xrawards.aixr.org/winners-and-finalists-2024/#category-xr-education-training-of-the-year",
    },
    {
      project: "Hoisting and Rigging VR (Finalist)",
      award: "VR Education and Training Solution of the Year",
      event: "AIXR, VR Awards",
      year: "2024",
      href: "https://xrawards.aixr.org/winners-and-finalists-2024/#category-xr-education-training-of-the-year",
    },
    {
      project: "FiAR (Finalist)",
      award: "Obsidian Award",
      event: "AIXR, VR Awards",
      year: "2024",
      href: "https://xrawards.aixr.org/winners-and-finalists-2024/#category-obsidian-award",
    },
    {
      project: "Certi-Fire VR",
      award: "VR Education and Training Solution of the Year",
      event: "AIXR, VR Awards",
      year: "2023",
      href: "https://xrawards.aixr.org/winners-and-finalists-2023/#category-vr-education-and-training-solution-of-the-year",
    },
    {
      project: "Vale VR Pre-Op",
      award: "VR Education and Training Solution of the Year",
      event: "AIXR, VR Awards",
      year: "2021",
      href: "https://xrawards.aixr.org/winners-and-finalists-2021/#category-vr-education-and-training-solution-of-the-year",
    },
    {
      project: "MyIBT",
      award: "SDS Awards - Web & Interactive",
      event: "Sudbury Design Society",
      year: "2021",
      href: "https://www.sudburydesignsociety.com/myibt-norcat",
    },
    {
      project: "Ontario Mine Rescue",
      award: "FWA",
      event: "FWA of the Day",
      year: "2021",
      href: "https://thefwa.com/cases/ontario-mine-rescue-vr",
    },
  ];

  return (
    <section className="accx-section">
      <style>{`
        .accx-section{
          background:#000;
          padding: 6.5rem 0;
          width:100%;
        }

        .accx-kicker{
          font-size: 1.15rem;
          letter-spacing: .14rem;
          text-transform: uppercase;
          color: rgba(255,255,255,.55);
          margin-bottom: 1.6rem;
        }

        .accx-list{
          width:100%;
          border-top: 1px solid rgba(255,255,255,.18);
        }

        /* clickable row */
        .accx-row{
          width:100%;
          display:grid !important;
          grid-template-columns: 1.15fr 1.55fr 1fr;
          align-items:center;
          gap: 2.2rem;

          padding: 2rem 0;
          border-bottom: 1px solid rgba(255,255,255,.18);
          position:relative;

          background: transparent;
          text-decoration: none;

          cursor: pointer;
          user-select: none;
          -webkit-user-select: none;
          transition: background .25s ease;
        }

        /* left accent bar on hover */
        .accx-row::before{
          content:"";
          position:absolute;
          left:-18px;
          top:14px;
          bottom:14px;
          width:0;
          opacity:0;
          border-radius:999px;
          background: var(--slope-main-color, #EA0029);
          transition: width .25s ease, opacity .25s ease;
        }
        .accx-row:hover{
          background: rgba(255, 255, 255, 0);
        }
        .accx-row:hover::before{
          width:6px;
          opacity:1;
        }

        /* typography */
        .accx-project{
          font-size: 1.33rem;
          line-height: 3rem;
          font-weight: 700;
          color: rgba(255,255,255,.92);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .accx-award{
          font-size: 1.33rem;
          line-height: 3rem;
          font-style: italic;
          font-weight: 500;
          color: rgba(255,255,255,.92);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .accx-meta{
          display:flex;
          justify-content:flex-end;
          align-items:center;
          gap: 1.2rem;
          white-space: nowrap;
          min-width: 0;
        }
        .accx-metaText{
          font-size: 1.33rem;
          line-height: 3rem;
          font-weight: 600;
          color: rgba(255,255,255,.55);
        }

        /* external link icon button (no movement) */
        .accx-iconBtn{
          width: 36px;
          height: 36px;
          border-radius: 999px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0);
          transition: background .25s ease;
          flex: 0 0 auto;
        }
        .accx-row:hover .accx-iconBtn{
          background: rgba(255, 255, 255, .08);
        }

        .accx-icon{
          width: 16px;
          height: 16px;
          display:block;
          opacity: .95;
        }
        .accx-icon path{
          stroke: #fff;
        }

        /* focus */
        .accx-row:focus{ outline: none; }
        .accx-row:focus-visible{
          outline: 2px solid rgba(255,255,255,.35);
          outline-offset: 6px;
          border-radius: 6px;
        }

        /* mobile */
        @media (max-width: 767px){
          .accx-row{
            grid-template-columns: 1fr;
            gap: .55rem;
            padding: 1.7rem 0;
          }
          .accx-meta{
            justify-content:flex-start;
          }
          .accx-row::before{
            left:-14px;
          }
        }
      `}</style>

      <div className="container">
        <div className="row">
           <div className="col-md-10">
           <h2 className="heading heading-large light-1">Proud of the journey, and thankful for the recognition along the way.</h2><br/><br/><br/>
           </div>
          <div className="col-lg-12">
            <div className="accx-kicker">ACCOLADES</div>

            <div className="accx-list">
              {accolades.map((a, i) => (
                <a
                  className="accx-row"
                  key={`${a.project}-${i}`}
                  href={a.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="accx-project">{a.project}</div>

                  <div className="accx-award">{a.award}</div>

                  <div className="accx-meta">
                    <span className="accx-metaText">
                      {a.event}, {a.year}
                    </span>

                    <span className="accx-iconBtn" aria-hidden="true">
                      <svg className="accx-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M14 5h5v5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10 14L19 5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M19 14v5H5V5h5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </div>
                </a>
              ))}
            </div>

          </div>
        </div>
      </div>
      <br /><br />
    </section>
  );
}
